var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSensorChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2067_22544",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#384663"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2067_22544)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5,
    fill: "#2E3A54"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.48195e-9,
    y1: 5.46436,
    x2: 40,
    y2: 5.46436,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.48195e-9,
    y1: 11.1787,
    x2: 40,
    y2: 11.1787,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.48195e-9,
    y1: 16.8931,
    x2: 40,
    y2: 16.8931,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.48195e-9,
    y1: 22.6072,
    x2: 40,
    y2: 22.6072,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.48195e-9,
    y1: 28.3213,
    x2: 40,
    y2: 28.3213,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.96868e-9,
    y1: 34.0356,
    x2: 40,
    y2: 34.0356,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("line", {
    opacity: 0.2,
    x1: -3.96868e-9,
    y1: 39.75,
    x2: 40,
    y2: 39.75,
    stroke: "#5C73A4",
    strokeWidth: 0.5,
    strokeDasharray: "4 1.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.701 25.3747C38.6533 24.3846 37.6321 23.4625 36.5543 23.4625C35.7135 23.4625 34.907 24.0238 34.0955 24.5887C33.4889 25.0109 32.8795 25.4351 32.2509 25.6281C30.8863 26.0793 29.4168 25.1769 28.0523 23.9136C26.5828 22.6503 25.1133 20.9359 23.7488 18.4093C23.4226 17.8484 23.1016 17.2476 22.7835 16.6521C21.6684 14.565 20.5886 12.5439 19.4453 12.5439C18.6186 12.5439 17.7534 13.7694 16.873 15.0164C16.3003 15.8277 15.721 16.648 15.1418 17.146C14.2934 17.9314 13.4044 17.9146 12.5253 17.8979C11.9905 17.8877 11.4594 17.8777 10.9433 18.0483C9.58693 18.3815 8.31998 19.8678 6.97737 21.4429C6.86541 21.5743 6.75293 21.7063 6.63982 21.8382C5.2753 23.4625 3.80581 25.1769 2.33632 26.0793C0.971802 26.8914 -0.497684 26.8914 -1.86221 24.7258C-2.04486 24.4678 -2.22589 24.1764 -2.4043 23.8598",
    stroke: "#2D9CDB",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSensorChart);
export default __webpack_public_path__ + "static/media/sensor-chart.abae9ad4.svg";
export { ForwardRef as ReactComponent };